module.exports = __webpack_public_path__ + "img/carousel-2.578286ae.png";